import { Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CentroResultadoService } from '@app/modules/centro_resultado/services/centro_resultado.service';
import { Utils } from '@app/shared/helpers/utils';
import { filter } from 'rxjs/operators';
import { CustomValidators, TokenService } from 'viggo-sistemas-core-web';

@Component({
  selector: 'app-fast-centro-resultado',
  templateUrl: './fast-centro-resultado.component.html',
  styleUrls: ['./fast-centro-resultado.component.scss'],
  providers: [CentroResultadoService]
})
export class FastCentroResultadoComponent implements OnInit {
  form: UntypedFormGroup;

  loading = false;

  constructor(
    protected fb: UntypedFormBuilder,
    protected entityService: CentroResultadoService,
    protected snackBar: MatSnackBar,
    protected dialogRef: MatDialogRef<FastCentroResultadoComponent>,
    protected tokenService: TokenService
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      descricao: [
        '',
        [
          Validators.required,
          Validators.maxLength(255),
          CustomValidators.isEmptyValue()
        ]
      ],
      centro_resultado: [
        null,
        [CustomValidators.isEmptyValue(), CustomValidators.typeIs('object')]
      ]
    });
  }

  onSubmit() {
    this.loading = true;
    var entity = {
      domain_id: this.tokenService.getDomain().id,
      ...this.form.value
    };
    delete entity.centro_resultado;
    entity.centro_resultado_id = this.form.value.centro_resultado ? this.form.value.centro_resultado.id : null;
    entity = Utils.trimAttributes(entity);

    if (this.form.valid) {
      this.entityService
        .insert(entity)
        .pipe(filter(result => !!result))
        .subscribe(
          formPgmt => {
            this.loading = false;
            this.dialogRef.close(formPgmt);
            this.snackBar.open(
              'Centro de resultado cadastrado com sucesso.',
              'X',
              {
                duration: 2000,
                horizontalPosition: 'right',
                verticalPosition: 'top',
                panelClass: ['msg-success']
              }
            );
          },
          () => {
            this.loading = false;
            this.snackBar.open('Erro ao cadastrar centro de resultado.', 'X', {
              duration: 2000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-error']
            });
          }
        );
    }
  }
}
